module.exports = __webpack_public_path__ + "img/help_06.efea3209.png";